import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const quickSearchResultsSchema = new schema.Entity('quickSearchResultsContainer', {
    results: [schemas.quickSearchResult]
});

export const userSearchResultsSchema = new schema.Entity('userSearchResultsContainer', {
    results: [schemas.userSearchResult]
});

export const diagSearchResultsSchema = new schema.Entity('diagSearchResultContainer', {
    results: [schemas.diagSearchResult]
});



